import React from "react";
import { AddShippingDTO } from "../../../../models/shipping";
import { Button, IconDelete, IconEdit } from "@touche-lts/panel-ui/dist";
import styles from "./shipping-item.module.scss";

interface ShippingItemProps {
  shipping: AddShippingDTO;
  onEdit: (index: number) => void;
  onRemove: (index: number) => void;
  index: number;
}

const ShippingItem: React.FC<ShippingItemProps> = (props) => {
  const { shipping, onEdit, onRemove, index } = props;

  return (
    <div className={styles.shippingItemContainer}>
      <div className={styles.shippingDetails}>
        <div className={styles.detailRow}>
          <div className={styles.detailLabel}>Name</div>
          <div>{shipping.name}</div>
        </div>
        <div className={styles.detailRow}>
          <div className={styles.detailLabel}>Price</div>
          {shipping.freeShipping ? (
            <div>Free shipping</div>
          ) : (
            <div>
              {shipping.price} {shipping.currency}
            </div>
          )}
        </div>
        <div className={styles.detailRow}>
          <div className={styles.detailLabel}>Ships to</div>
          <div className={styles.countriesContainer}>
            {shipping.countries.map((country) => (
              <div key={country} className={styles.countryTag}>
                {country}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.actionsContainer}>
        <Button
          preset="icon"
          title="Edit shipping option"
          className={styles.editButton}
          onClick={() => onEdit(index)}
        >
          <IconEdit fill={"#000000"} />
        </Button>
        <Button
          preset="icon"
          title="Remove shipping option"
          className={styles.deleteButton}
          onClick={() => onRemove(index)}
        >
          <IconDelete fill="red" />
        </Button>
      </div>
    </div>
  );
};

export default ShippingItem;
